export {BadgeAnchor, StyledRmwcBadgeAnchor} from './badge-anchor'
